/*!
 * Copyright (c) REWE Digital GmbH
 */
import { h, Host } from "@stencil/core";
/**
 * This component represents a circular progress spinner.
 *
 * @example
 *
 * <vx-circular-progress size="32" show="true"/>
 */
// eslint-disable-next-line require-jsdoc
export class VxCircularProgress {
    constructor() {
        this.size = 32;
        this.show = false;
    }
    /**
     * Renders the component.
     *
     * @returns {JSX.Element} The rendered component.
     */
    render() {
        return this.show && (h(Host, { key: '4569e3522501b6141019cde89fa654326ac96f36' }, h("svg", { key: '6c98cdad9d89aabc0ff164eceac62be9772a2454', class: "mdc-circular-progress", viewBox: "25 25 50 50", style: { height: this.size + 'px', width: this.size + 'px' } }, h("circle", { key: '5373cf27d87932ac56265c7b0b18af560e1ef16f', class: "mdc-circular-progress__path", "stroke-width": "2", fill: "none", "stroke-miterlimit": "10", cx: "50", cy: "50", r: "20" }))));
    }
    static get is() { return "vx-circular-progress"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-circular-progress.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-circular-progress.css"]
        };
    }
    static get properties() {
        return {
            "size": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The size of the spinner."
                },
                "attribute": "size",
                "reflect": false,
                "defaultValue": "32"
            },
            "show": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Show the spinner if true."
                },
                "attribute": "show",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
}
//# sourceMappingURL=vx-circular-progress.js.map
